import React from 'react';
import SEO from '../components/SEO';

export default function PrivacyPolicy({ lang }) {
  const seoData = {
    en: {
      title: 'Privacy Policy',
      description: 'How we handle your data at Beer Pass Project. No tracking, no bullshit.'
    },
    es: {
      title: 'Política de Privacidad',
      description: 'Cómo manejamos tus datos en el Proyecto Pase Cervecero. Sin rastreo, sin excusas.'
    }
  };

  const currentSeo = seoData[lang];

  const content = {
    en: {
      title: 'Privacy Policy',
      intro: 'We care about your privacy. Here is the breakdown.',
      sections: [
        { h: '1. Data Collection', p: 'We only collect what we need to get you your beer. This includes your email and basic payment info processing via third parties.' },
        { h: '2. Usage', p: 'Your data is used to validate your pass at partner taprooms. We don\'t sell your data to corporate giants. We hate them too.' },
        { h: '3. Cookies', p: 'We use essential cookies to keep you logged in. No tracking pixels from creepy social networks.' },
        { h: '4. Your Rights', p: 'You can ask us to delete everything at any time. Just send us an email.' }
      ]
    },
    es: {
      title: 'Privacidad',
      intro: 'Nos importa tu privacidad. Aquí está el desglose.',
      sections: [
        { h: '1. Recolección de Datos', p: 'Solo recolectamos lo necesario para darte tu cerveza. Esto incluye tu email e información básica de pago procesada por terceros.' },
        { h: '2. Uso', p: 'Tus datos se usan para validar tu pase en las cervecerías asociadas. No vendemos tus datos a gigantes corporativos. También los odiamos.' },
        { h: '3. Cookies', p: 'Usamos cookies esenciales para mantener tu sesión. Nada de píxeles de seguimiento de redes sociales raras.' },
        { h: '4. Tus Derechos', p: 'Puedes pedirnos que borremos todo en cualquier momento. Solo envíanos un email.' }
      ]
    }
  };

  const current = content[lang];

  return (
    <section className="w-full py-16 animate-in fade-in slide-in-from-bottom-4 duration-700">
      <SEO title={currentSeo.title} description={currentSeo.description} lang={lang} />
      <h1 className="text-5xl sm:text-7xl font-black uppercase mb-4 border-b-8 border-amber-400 pb-4 inline-block">
        {current.title}
      </h1>
      <p className="text-2xl font-black uppercase text-white bg-red-600 px-4 py-2 mt-8 mb-12 inline-block">
        {current.intro}
      </p>
      
      <div className="grid gap-12">
        {current.sections.map((sec, i) => (
          <div key={i} className="bg-zinc-900 p-8 border-2 border-zinc-800 shadow-[4px_4px_0_0_#ffffff]">
            <h2 className="text-2xl font-black uppercase text-amber-400 mb-4">{sec.h}</h2>
            <p className="text-lg font-bold text-gray-300 leading-relaxed">
              {sec.p}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}